module.exports = {"210781001":"大凌河街道","210781002":"金城街道","210781003":"八千街道","210781004":"大有街道","210781101":"石山镇","210781102":"余积镇","210781103":"双羊镇","210781104":"班吉塔镇","210781105":"沈家台镇","210781106":"三台子镇","210781107":"右卫满族镇","210781108":"阎家镇","210781109":"新庄子镇","210781112":"翠岩镇","210781113":"安屯镇","210781114":"大业镇","210781116":"建业镇","210781117":"温滴楼满族镇","210781118":"白台子镇","210781212":"板石沟乡","210781217":"谢屯乡","210781401":"辽宁省金城原种场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210781.json
// module id = 556
// module chunks = 0